module.exports = __webpack_public_path__ + "static/media/cmie.d97686d0.png";